import React from 'react';
import {transactionType} from '../../../Page/TransactionSummaryPage/Shared/Constants';

export function  constructPurchasedPrice(price, numOfInstallments, pricePerMonth = '', dealType = '',effectiveInterest = '',hasPayWithCash = '') {
  //let priceToPresent = parseFloat(price).toFixed(2).toString();
  const hasEffectiveInterest = effectiveInterest !== '' && effectiveInterest !== undefined;
  const hasInstallments =
    numOfInstallments !== '' && numOfInstallments !== undefined && numOfInstallments !== '0' && numOfInstallments !== '1';
  // if it's an additional charge or is it a purchased equipment (different presentation in summary)
  //if(pricePerMonth !== "") priceToPresent = pricePerMonth;
  return (
    <div className='block-frame__price-holder'>
      {!pricePerMonth && (
        <span className='block-frame__price block-frame__price--1'>
          <strong>
            {price && <span className='nis-sign'>&#8362; {numOfInstallments && pricePerMonth ? '' : price}</span>}
            {hasInstallments && pricePerMonth}
          </strong>
        </span>
      )}
      {pricePerMonth && dealType != transactionType.CancelDeal && (
        <span className='block-frame__price block-frame__price--1'>
          <strong>
            <span className='nis-sign'>&#8362; {numOfInstallments && pricePerMonth ? '' : price}</span>
            {hasInstallments && pricePerMonth}
            {!hasInstallments && price}
          </strong>
          {hasInstallments && pricePerMonth && <span className='installments'>{' x' + numOfInstallments}</span>}
        </span>
      )}
      {hasInstallments && pricePerMonth && (
        <span className='block-frame__price block-frame__price--2'>
          &#8362; {price}
          {' סה"כ'}
        </span>
      )}
      {hasEffectiveInterest && (
          <span className='block-frame__price block-frame__price--3'>
           {effectiveInterest}&#37;
            {' ריבית אפקטיבית'}
        </span>
      )}
      {hasPayWithCash && (
          <span className='block-frame__price block-frame__price--3'>
         &#8362; {hasPayWithCash}
            {' מחיר מזומן'}
        </span>
      )}
      {/*             {hasInstallments && pricePerMonth !== "" && <span className="block-frame__price block-frame__price--2">&#8362;{price}{" סה\"כ"}</span>}
       */}{' '}
    </div>
  );
}

export function setPriceCyclesDescription(priceCycles, onePaymentCharge = '', isCancelled = false) {
  let startMonth = 1;
  let endMonth = 0;
  let priceCyclesDescription = '';
  if (onePaymentCharge !== '') {
    // it could be service with one time payment
    priceCyclesDescription = (
      <span className={'block-frame__price--1' + (isCancelled ? ' cancelled' : '')}>
        <strong>
          <span className='nis-sign'>&#8362;</span>
          {onePaymentCharge}
        </strong>
      </span>
    );
  } else if (checkRegularPayment(priceCycles)) {
    // regular payment means x nis/month for the service
    priceCyclesDescription = (
      <span className={'block-frame__price--1' + (isCancelled ? ' cancelled' : '')}>
        <strong>
          <span className='nis-sign'>&#8362;</span>
          {priceCycles[0].price}
        </strong>
      </span>
    );
  } else {
    priceCyclesDescription = priceCycles.map((cycle, idx) => {
      let cycleDescription;
      const price = cycle.price;
      if (cycle.duration !== '' && cycle.duration !== '0' && cycle.durationUnit !== '') {
        const prevCycle = idx > 0 ? priceCycles[idx - 1] : null;
        const durationChanged = !prevCycle || prevCycle.duration !== cycle.duration;
        if (durationChanged) {
          endMonth = startMonth + parseInt(cycle.duration) - 1;
        }
        cycleDescription = (
          <div className={'block-frame__cycle-row' + (isCancelled ? ' cancelled' : '')} key={idx}>
            <span>{cycle.durationUnit === "cycles" ? "מחזור חיוב" : "חודשים"} {startMonth.toString() + '-' + endMonth.toString()}</span>
            <span className='block-frame__price--1'>
              <strong>
                <span className='nis-sign'>&#8362;</span>
                {price}
              </strong>
            </span>
          </div>
        );
        const nextCycle = priceCycles[idx + 1];
        if (!nextCycle || nextCycle.duration !== cycle.duration) {
          startMonth = endMonth + 1;
        }
      } else if (cycle.duration === '' || cycle.duration === '0') {
        cycleDescription = (
          <div className={'block-frame__cycle-row' + (isCancelled ? ' cancelled' : '')} key={idx}>
          <span>
           {cycle.durationUnit === "cycles" ? "ממחזור חיוב" : "מחודש"} {startMonth}
          </span>
            <span className='block-frame__price--1'>
              <strong>
                <span className='nis-sign'>&#8362;</span>
                {price}
              </strong>
            </span>
          </div>
        );
      } else cycleDescription = '';

      return cycleDescription;
    });
  }

  return priceCyclesDescription;
}

export function checkRegularPayment(priceCycles) {
  return priceCycles.length === 1 && (priceCycles[0].duration === '' || priceCycles[0].duration === '0');
}

export function setStatusStyle(action = '') {
  let statusStyle = '';

  switch (action.toLowerCase()) {
    case 'add':
      statusStyle = '--2';
      break;
    case 'disconnect':
    case 'remove':
      statusStyle = '--1';
      break;
    case 'exists':
      statusStyle = '--3';
      break;
    default:
      break;
  }

  return statusStyle;
}

export function checkSectionValid(sectionDetails) {
  let isValid = false;
  try {
    if (sectionDetails !== null && sectionDetails !== undefined && Object.keys(sectionDetails).length > 0) {
      if (sectionDetails.statusMessage.returnCode === '00') {
        const boolArr = Object.keys(sectionDetails).map((detail) => {
          // check existing lists not empty
          if (sectionDetails[detail] instanceof Array) {
            return Object.keys(sectionDetails[detail]).length > 0;
          }
        });

        if (boolArr.filter((bool) => bool === true || bool === false).length === 0) isValid = true; // if no list exists in section

        if (boolArr.filter((bool) => bool === true).length > 0) isValid = true;
      }
    }
  } catch (ex) {
    isValid = false;
  }

  return isValid;
}
